"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.verifyUserLegalAge = exports.kickOff = exports.VERIFY_USER_HAS_LEGAL_AGE = exports.KICK_OFF = void 0;
var ROOT = '@@appshell';
var KICK_OFF = "".concat(ROOT, "/KICK_OFF");
exports.KICK_OFF = KICK_OFF;
var VERIFY_USER_HAS_LEGAL_AGE = "".concat(ROOT, "/VERIFY_USER_HAS_LEGAL_AGE");
exports.VERIFY_USER_HAS_LEGAL_AGE = VERIFY_USER_HAS_LEGAL_AGE;

var kickOff = function kickOff() {
  return {
    type: KICK_OFF
  };
};

exports.kickOff = kickOff;

var verifyUserLegalAge = function verifyUserLegalAge(hasUserLegalAge) {
  return {
    type: VERIFY_USER_HAS_LEGAL_AGE,
    hasUserLegalAge: hasUserLegalAge
  };
};

exports.verifyUserLegalAge = verifyUserLegalAge;